/* AllFun Games — anonymous site statistics (17.10). First-party and cookie-free, like the games'
   (games/<slug>/src/ads.ts): the home page says it was opened ({t:'open', g:'home'}), and a tap on a link
   to a game says which game ({t:'click', g:<slug>}). With it goes only a random id this browser keeps in
   localStorage (allfun.sid.v1, the same one the games use) so the server can count unique visitors.
   Nothing else. Off with Do Not Track; fails silently without a server. */
(function () {
  'use strict';
  try {
    if (!/^https?:$/.test(location.protocol) || navigator.doNotTrack === '1') return;
  } catch (e) { return; }
  var URL_EV = '/api/ev', KEY = 'allfun.sid.v1', id = null;

  function sid() {
    if (id) return id;
    try { var old = localStorage.getItem(KEY); if (old && /^[A-Za-z0-9_-]{16,40}$/.test(old)) return (id = old); } catch (e) {}
    var abc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_', bytes = new Uint8Array(16), out = '';
    try { crypto.getRandomValues(bytes); } catch (e) { for (var j = 0; j < 16; j++) bytes[j] = Math.floor(Math.random() * 256); }
    for (var i = 0; i < 16; i++) out += abc.charAt(bytes[i] & 63);
    try { localStorage.setItem(KEY, out); } catch (e) {}
    return (id = out);
  }

  function send(t, g) {
    try {
      var body = JSON.stringify({ v: 1, id: sid(), events: [{ t: t, g: g, ts: Date.now() }] });
      if (navigator.sendBeacon && navigator.sendBeacon(URL_EV, body)) return;
      fetch(URL_EV, { method: 'POST', body: body, keepalive: true }).catch(function () {});
    } catch (e) {}
  }

  var path = location.pathname;
  if (path === '/' || path === '/index.html') send('open', 'home');

  // A link to a game is /<slug>/ (letters only); the menu, the dock, the tiles and the chips all are.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    try {
      var to = new URL(a.getAttribute('href'), location.href);
      if (to.origin !== location.origin) return;
      var m = /^\/([a-z]{1,20})\/?(index\.html)?$/.exec(to.pathname);
      if (m) send('click', m[1]);
    } catch (err) {}
  }, true);
})();
